import React from 'react';
import {
  Box,
  Container,
  Paper,
  Tab,
  Tabs,
  SvgIcon,
} from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { CalendarMonth as CalendarMonthIcon } from '@mui/icons-material';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import BlocksContent from '../components/BlocksContent';
import NotionLinkOnly from '../components/NotionLinkOnly';
import TabPanel from '../components/TabPanel';

const CubeIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 3L21 7.5L12 12L3 7.5Z" />
    <path d="M21 7.5V16.5L12 21V12Z" opacity="0.7" />
    <path d="M3 7.5L12 12V21L3 16.5Z" opacity="0.45" />
  </SvgIcon>
);

const UpcomingPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentTab = () => {
    if (location.pathname.includes('/blocks')) {
      return 1;
    }
    return 0;
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) {
      navigate('/upcoming/days');
    } else if (newValue === 1) {
      navigate('/upcoming/blocks');
    }
  };

  return (
    <Box>
      <Paper elevation={1} square sx={{ mb: 4 }}>
        <Tabs
          value={getCurrentTab()}
          onChange={handleTabChange}
          centered
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            icon={<CalendarMonthIcon />}
            label="DAYS"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
          <Tab
            icon={<CubeIcon />}
            label="Blocks"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
        </Tabs>
      </Paper>

      <Container
        maxWidth="lg"
        sx={{
          px: { xs: 1.5, sm: 2, md: 3 },
          userSelect: { xs: 'none', sm: 'auto' },
          WebkitUserSelect: { xs: 'none', sm: 'auto' },
          WebkitTouchCallout: { xs: 'none', sm: 'default' },
          '& input, & textarea, & [contenteditable="true"]': {
            userSelect: { xs: 'text', sm: 'auto' },
            WebkitUserSelect: { xs: 'text', sm: 'auto' },
          },
        }}
      >
        <Routes>
          <Route path="/" element={<Navigate to="/upcoming/days" replace />} />
          <Route path="/days/*" element={
            <TabPanel value={getCurrentTab()} index={0}>
              <NotionLinkOnly />
            </TabPanel>
          } />
          <Route path="/blocks/*" element={
            <TabPanel value={getCurrentTab()} index={1}>
              <BlocksContent />
            </TabPanel>
          } />
        </Routes>
      </Container>
    </Box>
  );
};

export default UpcomingPage;